/* StowPro WhatsApp widget — behaviour. Loaded by snippets/whatsapp-widget-custom.liquid */
// ---- Widget open/close (demo interaction) ----
    const widget   = document.getElementById('waWidget');
    const launcher = document.getElementById('waLauncher');
    const closeBtn = document.getElementById('waClose');
    const badge    = launcher.querySelector('.wa-badge');

    function setOpen(open){
      widget.classList.toggle('open', open);
      launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(open && badge) badge.style.display='none';
    }
    function toggle(){ setOpen(!widget.classList.contains('open')); }
    launcher.addEventListener('click', toggle);
    closeBtn.addEventListener('click', () => setOpen(false));

    // Escape closes the panel and puts focus back on the launcher, so a
    // keyboard user is not stranded inside it.
    document.addEventListener('keydown', e => {
      if(e.key === 'Escape' && widget.classList.contains('open')){
        setOpen(false);
        launcher.focus();
      }
    });

    // ---- Minimise: customer can dismiss the widget entirely ----
    // The choice is remembered for the rest of the browsing session, so it does
    // not reappear on every page they click through to. sessionStorage (not
    // localStorage) means it clears when they close the tab, so the widget is
    // back on their next visit rather than dismissed forever.
    const dismiss = document.getElementById('waDismiss');
    const reopen  = document.getElementById('waReopen');
    const DISMISS_KEY = 'stowpro-wa-dismissed';

    // Private browsing and some privacy settings make storage throw on access,
    // so a storage failure must never stop the widget working.
    function remember(isDismissed){
      try {
        if(isDismissed) sessionStorage.setItem(DISMISS_KEY, '1');
        else sessionStorage.removeItem(DISMISS_KEY);
      } catch(e){ /* storage unavailable — widget still works, just won't persist */ }
    }
    function wasDismissed(){
      try { return sessionStorage.getItem(DISMISS_KEY) === '1'; }
      catch(e){ return false; }
    }

    function hideWidget(e){
      if(e) e.stopPropagation();
      setOpen(false);
      widget.classList.add('hidden');
      remember(true);
    }
    dismiss.addEventListener('click', hideWidget);
    dismiss.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' '){ e.preventDefault(); hideWidget(e); } });
    reopen.addEventListener('click', () => { widget.classList.remove('hidden'); remember(false); });

    // Restore the dismissed state on each subsequent page.
    if(wasDismissed()) widget.classList.add('hidden');

    // ---- Business-hours status ----
    // The days and hours come from the theme settings as data attributes on
    // the widget, so the open/closed state here and the hours printed in the
    // panel can never disagree — they are the same source. Locked to UK time
    // (Europe/London), so it's correct no matter where the visitor is.
    function refreshHours(){
      const DAY_SETS = {
        mon_fri:  ['Mon','Tue','Wed','Thu','Fri'],
        mon_sat:  ['Mon','Tue','Wed','Thu','Fri','Sat'],
        everyday: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
      };
      const openHour  = parseInt(widget.dataset.openHour, 10);
      const closeHour = parseInt(widget.dataset.closeHour, 10);
      const openDays  = DAY_SETS[widget.dataset.days] || DAY_SETS.mon_fri;
      const agent     = widget.dataset.agent || 'We';
      const hoursText = widget.dataset.hoursText || '';

      // Read the current time in the UK (Europe/London) regardless of
      // where the visitor's own clock is set. Handles GMT/BST automatically.
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', hour12: false
      }).formatToParts(new Date());
      const wd   = parts.find(p => p.type === 'weekday').value;      // Mon, Tue …
      let   hour = parseInt(parts.find(p => p.type === 'hour').value, 10);
      if (hour === 24) hour = 0;                                     // midnight guard
      const open = openDays.includes(wd) && hour >= openHour && hour < closeHour;

      const dot    = document.getElementById('waDot');
      const status = document.getElementById('waStatus');
      const hours  = document.getElementById('waHours');

      if(open){
        dot.style.background = '#25D366';
        status.textContent   = 'Typically replies quickly';
        hours.textContent    = 'Opens WhatsApp · we never spam';
      } else {
        dot.style.background = '#8696a0';                 // grey = offline
        status.textContent   = agent + ' is away · ' + hoursText;
        hours.textContent    = 'We’re offline now — leave a message and we’ll reply when we’re back.';
      }
    }
    refreshHours();
    setInterval(refreshHours, 60000);     // re-check every minute

